import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isAgentHubBdmEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isAgentHubBdmEnabled>[0];
  isLoading: boolean;
}>;

export default function AgentHubBdmRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isAgentHubBdmEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
